export default "__VITE_ASSET__DDTIytAG__"